import * as React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'
import _ from 'lodash'

import Separator from 'modules/core/components/Separator'
import type { Types } from 'modules/core/components/Separator'

import styles from './index.module.scss'

const cx = classNames.bind(styles)
interface Props {
  type?: Types
  description?: string
  separator?: boolean
  step: number
  steps: number
  title?: string
}

const Steps = ({ description, separator = false, step, steps, title, type = 'brand' }: Props) => {
  return (
    <div>
      <div className={styles.steps}>
        {_.range(0, steps).map((s, i) => {
          const dotCompleted = step > i + 1
          const dotActive = step >= i + 1
          const lineActive = step >= i + 2

          const dotContent = dotCompleted ? (
            <Icon.Medium icon="check" color="grey000White" />
          ) : (
            s + 1
          )

          return (
            <div className={styles.container} key={i}>
              <div
                className={cx('step', {
                  active: dotActive,
                })}
              >
                {dotContent}
              </div>
              <div
                className={cx('line', {
                  active: lineActive,
                })}
              />
            </div>
          )
        })}
      </div>
      {(!!title || !!description) && (
        <div className={styles.footer}>
          {!!title && <div className={styles.title}>{title}</div>}
          {!!description && <div className={styles.description}>{description}</div>}
          {separator && (
            <div className={styles.separator}>
              <Separator compact type={type} />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default Steps
